module.exports = function() {
  return new Worker(__webpack_public_path__ + "1af6fb5923a4964d6cf5.worker.js");
};